import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { TCoreAction } from '@/store/types/modals.types';
import {
  IOnboardingConfig,
  TIntegrationConfigAction,
  IntegrationConfigActionTypes,
} from '@/store/types/integration-config.types';

import { IntegrationConfigService } from '@/services/IntegrationConfigService';

import { TAppState } from '@/store/reducers/reducers';
import { TAppError } from '@/store/types/base.state';

import { closeModal } from '@/store/actions/core.actions';

export const getOnboardingUrl = (): ThunkAction<Promise<void>, TAppState, {}, TIntegrationConfigAction> => {
  const request = (): TIntegrationConfigAction => ({
    type: IntegrationConfigActionTypes.GET_ONBOARDING_URL,
  });
  const fail = (error: TAppError): TIntegrationConfigAction => ({
    type: IntegrationConfigActionTypes.GET_ONBOARDING_URL_FAIL,
    error,
    documentation: 'https://docs.treezor.com/guide/users/introduction.html#onboard-your-users-with-connect',
  });
  const success = (config: IOnboardingConfig): TIntegrationConfigAction => ({
    type: IntegrationConfigActionTypes.GET_ONBOARDING_URL_SUCCESS,
    onboardingUrl: config,
    shouldSkipToaster: true,
  });

  return async (dispatch: ThunkDispatch<TAppState, {}, TIntegrationConfigAction>): Promise<void> => {
    dispatch(request());
    try {
      const onboardingUrlConfigResponse = await IntegrationConfigService.getOnboardingUrl();

      dispatch(success(onboardingUrlConfigResponse));
    } catch (error) {
      dispatch(fail(error));
    }
  };
};

export const updateOnboardingUrl = (
  onboardingUrl: IOnboardingConfig,
): ThunkAction<Promise<void>, TAppState, {}, TIntegrationConfigAction | TCoreAction> => {
  const request = (): TIntegrationConfigAction => ({
    type: IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL,
  });
  const fail = (error: TAppError): TIntegrationConfigAction => ({
    type: IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL_FAIL,
    error,
    documentation: 'https://docs.treezor.com/guide/users/introduction.html#onboard-your-users-with-connect',
  });
  const success = (url: IOnboardingConfig): TIntegrationConfigAction => ({
    type: IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL_SUCCESS,
    onboardingUrl: url,
  });

  return async (dispatch: ThunkDispatch<TAppState, {}, TIntegrationConfigAction | TCoreAction>): Promise<void> => {
    dispatch(request());
    try {
      const updatedOnboardingUrl = await IntegrationConfigService.updateOnboardingUrl(onboardingUrl);

      dispatch(success(updatedOnboardingUrl));
      dispatch(closeModal());
    } catch (error) {
      dispatch(fail(error));
    }
  };
};
